var _desc, _path, _rect, _circle, _circle2, _circle3, _circle4, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Welcome Banner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Welcome banner decorative element")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 30 L90 30 L85 50 L90 70 L10 70 L15 50 Z",
    fill: "url(#bannerGradient)",
    stroke: "#C8B59B",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 60,
    height: 20,
    rx: 2,
    fill: "rgba(255,255,255,0.2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 3,
    fill: "#9EC630"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 3,
    fill: "#9EC630"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 60,
    r: 3,
    fill: "#9EC630"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 3,
    fill: "#9EC630"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 45,
    x2: 50,
    y2: 55,
    stroke: "#9EC630",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 50,
    x2: 55,
    y2: 50,
    stroke: "#9EC630",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bannerGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#D4C4A0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#C8B59B",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#D4C4A0",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBanner);
export default __webpack_public_path__ + "static/media/welcome-banner.6f696098ec30f7887d6687c49a36eb84.svg";
export { ForwardRef as ReactComponent };